module.exports = __webpack_public_path__ + "img/build.a76ce4f5.jpg";